module.exports = __webpack_public_path__ + "3333536d775a2a1e78ef846270820362.png";